import { useContext, useEffect, useLayoutEffect, useRef } from "react";
import invariant from "tiny-invariant";
import { getContext } from "./bootstrap";
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
export const useEvent = ({ callback, filter = () => false, delay, contextId, }) => {
    const { messaging: messagingContext } = getContext({ id: contextId });
    const { subscribe, unsubscribe } = useContext(messagingContext);
    invariant(subscribe, "You are trying to use the useEvent hook without wrapping your app with the <MessagingProvider>.");
    const filterRef = useRef(filter);
    const callbackRef = useRef(callback);
    // Layout effect on purpose: a passive effect would leave a window in which a
    // live subscriber still reads the previous render's filter/callback.
    useIsomorphicLayoutEffect(() => {
        filterRef.current = filter;
        callbackRef.current = callback;
    });
    useEffect(() => {
        let timeout;
        const subscriber = (event) => {
            if (!filterRef.current(event)) {
                return;
            }
            if (delay === undefined) {
                callbackRef.current();
                return;
            }
            clearTimeout(timeout);
            timeout = setTimeout(() => callbackRef.current(), delay);
        };
        subscribe(subscriber);
        return () => {
            clearTimeout(timeout);
            unsubscribe(subscriber);
        };
    }, [delay, subscribe, unsubscribe]);
};
